<template>
  <div class="eda-workspace">
    <div v-if="status === 'error'" class="eda-workspace-state">
      <div class="eda-workspace-error">Could not load EDA data: {{ error }}</div>
      <v-btn variant="outlined" class="text-none" @click="load(true)">Retry</v-btn>
    </div>
    <div v-else-if="status !== 'ready'" class="eda-workspace-state">
      <v-progress-circular indeterminate color="primary" />
      <div class="eda-workspace-progress">{{ progressText }}</div>
    </div>
    <component :is="analysisComponent" v-else />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { EDA_ANALYSIS_COMPONENTS, DEFAULT_EDA_ANALYSIS } from "../analyses";

export default {
  name: "EdaWorkspace",
  props: {
    analysisId: { type: String, required: true },
    tenantId: { type: String, required: true },
  },
  computed: {
    ...mapState("eda", ["status", "error", "progress"]),
    analysisComponent() {
      return EDA_ANALYSIS_COMPONENTS[this.analysisId] || EDA_ANALYSIS_COMPONENTS[DEFAULT_EDA_ANALYSIS];
    },
    progressText() {
      const { loaded, total } = this.progress;
      if (!loaded) return "Loading samples…";
      return total ? `Loading samples… ${loaded} / ${total}` : `Loading samples… ${loaded}`;
    },
  },
  watch: {
    tenantId() {
      this.load();
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load(force = false) {
      this.$store.dispatch("eda/loadData", { tenantId: this.tenantId, force });
    },
  },
};
</script>
